import { render, staticRenderFns } from "./modal-add-content.html?vue&type=template&id=8596abba&scoped=true&"
import script from "./modal-add-content.js?vue&type=script&lang=js&"
export * from "./modal-add-content.js?vue&type=script&lang=js&"
import style0 from "./modal-add-content.scss?vue&type=style&index=0&id=8596abba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8596abba",
  null
  
)

export default component.exports